import { lazy } from "react";

import Error401Page from "src/pages/401";
import Error404Page from "src/pages/404";
import Error500Page from "src/pages/500";
import { authRoutes } from "./auth";
import { dashboardRoutes } from "./dashboard";

const IndexPage = lazy(() => import("src/pages/index"));

export const routes = [
  ...authRoutes,
  ...dashboardRoutes,
  {
    index: true,
    element: <IndexPage />,
  },
  {
    path: "401",
    element: <Error401Page />,
  },
  {
    path: "404",
    element: <Error404Page />,
  },
  {
    path: "500",
    element: <Error500Page />,
  },
  {
    path: "*",
    element: <Error404Page />,
  },
];
